import httpClient from "../http-client";
import download from "downloadjs";

const generateEngagementReport = async (
  format: string,
  queryString: string
) => {
  const reportResponse = await httpClient.get(`reports/engagement/${format}`, {
    params: queryString,
    responseType: "blob",
  });

  const contentType = reportResponse.headers["content-type"];

  download(reportResponse.data, `relatório_engajamento.${format}`, contentType);
};

const generateCourseUserReport = async (
    format: string,
    queryString: string
) => {
  const reportResponse = await httpClient.get(`reports/contents-viewed/${format}`, {
    params: queryString,
    responseType: "blob",
  });

  const contentType = reportResponse.headers["content-type"];

  download(reportResponse.data, `relatório_curso_usuario.${format}`, contentType);
};

const generateTrailUserReport = async (
    format: string,
    queryString: string
) => {
  const reportResponse = await httpClient.get(`reports/trail-contents-viewed/${format}`, {
    params: queryString,
    responseType: "blob",
  });

  const contentType = reportResponse.headers["content-type"];

  download(reportResponse.data, `relatório_trilha_usuario.${format}`, contentType);
};

const generateAccessUsersReport = async (
    format: string,
    queryString: string
) => {
  const reportResponse = await httpClient.get(`reports/user-access/${format}`, {
    params: queryString,
    responseType: "blob",
  });

  const contentType = reportResponse.headers["content-type"];

  download(reportResponse.data, `relatório_acessos_usuarios.${format}`, contentType);
};

const generateFinishedCoursesReport = async (
  format: string,
  queryString: string
) => {
  const reportResponse = await httpClient.get(
    `reports/courses-finished/${format}`,
    {
      params: queryString,
      responseType: "blob",
    }
  );

  const contentType = reportResponse.headers["content-type"];

  download(
    reportResponse.data,
    `relatório_cursos_finalizados.${format}`,
    contentType
  );
};

export { generateEngagementReport, generateFinishedCoursesReport, generateCourseUserReport, generateTrailUserReport, generateAccessUsersReport };
